import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../util/utility";

const initialState = {
  result: [],
  loading: false,
  error: false,
  errorCode: null,
  success: false
};

const resetGenerateIdStore = (state, action) => {
  return updateObject(state, initialState);
};

const generateProductIdDownloadStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const generateProductIdDownloadSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: false,
    result: action.result,
    success: true
  });
};

const generateProductIdDownloadFail = (state, action) => {
  return updateObject(state, {
    error: true,
    loading: false,
    errorCode: action.error
  });
};

const generateProductIdEmailStart = (state, action) => {
  return updateObject(state, {
    loading: true
  });
};

const generateProductIdEmailSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: false,
    result: action.result,
    success: true
  });
};

const generateProductIdEmailFail = (state, action) => {
  return updateObject(state, {
    error: true,
    loading: false,
    errorCode: action.error
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.RESET_GENERATE_ID_STORE:
      return resetGenerateIdStore(state, action);

    case actionTypes.GENERATE_ID_DOWNLOAD_START:
      return generateProductIdDownloadStart(state, action);

    case actionTypes.GENERATE_ID_DOWNLOAD_SUCCESS:
      return generateProductIdDownloadSuccess(state, action);

    case actionTypes.GENERATE_ID_DOWNLOAD_FAIL:
      return generateProductIdDownloadFail(state, action);

    case actionTypes.GENERATE_ID_EMAIL_START:
      return generateProductIdEmailStart(state, action);

    case actionTypes.GENERATE_ID_EMAIL_SUCCESS:
      return generateProductIdEmailSuccess(state, action);

    case actionTypes.GENERATE_ID_EMAIL_FAIL:
      return generateProductIdEmailFail(state, action);

    default:
      return state;
  }
};

export default reducer;
